var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"qrcode"}}),_c('br'),_c('h3',[_vm._v("如果手机无法扫描，请手动录入: ")]),_c('p',[_vm._v(_vm._s(_vm.mfa))]),_c('br'),_c('h2',{staticStyle:{"color":"red"}},[_vm._v("录入完成，请联系管理员添加权限")])])
}
var staticRenderFns = []

export { render, staticRenderFns }